/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import * as React from 'react';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import useInfiniteScrollHandler from '@hooks/useInfiniteScrollHandler';
import { breakpoints } from '@styles/index';
import { CourseCarousel } from '../../Skeletons';

const ProgressWrapper = styled.div`
  grid-column: ${({ gridColumn }) => gridColumn};
  width: 484px;
  margin: auto;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    grid-column: span 10;
  }
`;

const InfiniteList = (props) => {
  const {
    data,
    _renderItem,
    loadMore,
    scrollElement,
    loaderType,
    rowItems,
    gridColumn,
    dataKey,
    loaderColor,
    RenderItem,
    getItemKey,
    extraProps
  } = props;
  const [isFetching, setIsFetching] = useInfiniteScrollHandler(
    // eslint-disable-next-line no-use-before-define
    onScrollEnd,
    scrollElement
  );

  React.useEffect(() => {
    setIsFetching(false);
  }, [dataKey]);

  function onScrollEnd() {
    if (data && !data.isFetching && isFetching) {
      if (data.next) {
        const loadPromise = loadMore();
        if (!loadPromise) return;
        loadPromise.then(() => {
          setIsFetching(false);
        });
      } else {
        setIsFetching(false);
      }
    }
  }

  const getLoader = () => {
    if (loaderType === 'course' || loaderType === 'batchGroup') {
      return <CourseCarousel number={rowItems} gridColumn={gridColumn} />;
    }
    if (loaderType === 'progress') {
      return (
        <ProgressWrapper gridColumn={gridColumn}>
          <CircularLoader color={loaderColor} />
        </ProgressWrapper>
      );
    }
  };

  if (!data) return null;

  const renderLoader = data.isFetching && loaderType !== 'disabled';
  return (
    <>
      {data.results?.map((item, index) => {
        if (RenderItem)
          return (
            <RenderItem
              item={item}
              key={getItemKey(item, index)}
              index={index}
              {...extraProps}
            />
          );
        return _renderItem(item, index);
      })}
      {renderLoader ? getLoader() : null}
    </>
  );
};

InfiniteList.propTypes = {
  _renderItem: PropTypes.func,
  RenderItem: PropTypes.elementType,
  loadMore: PropTypes.func,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  scrollElement: PropTypes.objectOf(PropTypes.any),
  rowItems: PropTypes.number,
  loaderType: PropTypes.oneOf(['progress', 'course', 'disabled']),
  gridColumn: PropTypes.string,
  dataKey: PropTypes.string,
  loaderColor: PropTypes.string,
  getItemKey: PropTypes.func,
  extraProps: PropTypes.objectOf(PropTypes.any)
};
InfiniteList.defaultProps = {
  loadMore: () => null,
  scrollElement: null,
  loaderType: 'progress',
  rowItems: 3,
  gridColumn: 'span 10',
  dataKey: '',
  loaderColor: 'var(--color-i-green)',
  getItemKey: (_, index) => index,
  extraProps: {},
  _renderItem: () => {},
  RenderItem: null
};
export default InfiniteList;
